import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon39: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#4775FF"
        d="M0 1.62C0 .402 1.294-.379 2.36.185L19.14 8.571c1.148.607 1.148 2.254-.01 2.865L2.37 19.812C1.294 20.382 0 19.6 0 18.382l.036-.185 3.273-8.196L.036 1.806 0 1.62Zm1.902-.546a.616.616 0 0 0-.897.463l3.181 7.964h8.044a.5.5 0 0 1 .492.41l.008.09a.5.5 0 0 1-.5.5H4.185l-3.18 7.964c.051.387.45.63.822.496l.085-.038 16.759-8.376c.438-.23.438-.86.01-1.087L1.902 1.074Z"
      />
    </Svg>
  )
}
